import { getServiceUrl } from '../api';
import RequestService from '../httpRequest';

function request(config) {
  const { url, method, data, headers, callback, failCallback, retry } = config;
  const builder = RequestService.sendRequest()
    .url(url)
    .method(method);

  if (headers) {
    builder.header(headers);
  }
  if (data !== undefined) {
    builder.data(data);
  }

  builder
    .success((res) => {
      RequestService.clearRequestTime();
      if (callback) {
        callback(res);
      }
    })
    .fail((res) => {
      if (failCallback) {
        failCallback(res);
      }
    })
    .networkFail(() => {
      if (retry) {
        RequestService.reAjaxFun(retry);
      }
    }).send();
}

function toQuery(params = {}) {
  const search = new URLSearchParams();
  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value !== undefined && value !== null && value !== '') {
      search.append(key, value);
    }
  });
  const query = search.toString();
  return query ? `?${query}` : '';
}

export default {
  intervene(payload, callback, failCallback) {
    request({
      url: `${getServiceUrl()}/agent/classroom/intervention`,
      method: 'POST',
      data: payload,
      callback,
      failCallback,
      retry: () => this.intervene(payload, callback, failCallback)
    });
  },

  connections(callback, failCallback) {
    request({
      url: `${getServiceUrl()}/agent/classroom/connections`,
      method: 'GET',
      callback,
      failCallback,
      retry: () => this.connections(callback, failCallback)
    });
  },

  batchImport(fileOrFormData, callback, failCallback) {
    const formData = fileOrFormData instanceof FormData ? fileOrFormData : new FormData();
    if (!(fileOrFormData instanceof FormData)) {
      formData.append('file', fileOrFormData);
    }

    request({
      url: `${getServiceUrl()}/agent/batch-import`,
      method: 'POST',
      headers: {},
      data: formData,
      callback,
      failCallback,
      retry: () => this.batchImport(fileOrFormData, callback, failCallback)
    });
  },

  applyConfig(payload, callback, failCallback) {
    request({
      url: `${getServiceUrl()}/agent/classroom/apply`,
      method: 'PUT',
      data: payload,
      callback,
      failCallback,
      retry: () => this.applyConfig(payload, callback, failCallback)
    });
  },

  buildExportChatHistoryUrl(params) {
    return `${getServiceUrl()}/agent/classroom/export-chat-history${toQuery(params)}`;
  },

  exportChatHistory(params) {
    window.open(this.buildExportChatHistoryUrl(params), '_blank');
  }
};
